export var StoreTypes;
(function(StoreTypes) {
    StoreTypes["OPEN_SUGGESTIONS"] = 'AUTOCOMPLETE:OPEN_SUGGESTIONS';
    StoreTypes["CLOSE_SUGGESTIONS"] = 'AUTOCOMPLETE:CLOSE_SUGGESTIONS';
    StoreTypes["SET_QUERY"] = 'AUTOCOMPLETE:SET_QUERY';
    StoreTypes["SET_VALUE"] = 'AUTOCOMPLETE:SET_VALUE';
    StoreTypes["SET_PREVIOUS_VALUE"] = 'AUTOCOMPLETE:SET_PREVIOUS_VALUE';
    StoreTypes["SET_SUGGESTIONS"] = 'AUTOCOMPLETE:SET_SUGGESTIONS';
    StoreTypes["SELECT_SUGGESTION"] = "SELECT_SUGGESTION";
    StoreTypes["SELECTING_SUGGESTION"] = "SELECTING_SUGGESTION";
    StoreTypes["CONFIRM_SUGGESTION"] = "CONFIRM_SUGGESTION";
    StoreTypes["CANCEL_SUGGESTION"] = "CANCEL_SUGGESTION";
})(StoreTypes || (StoreTypes = {}));
export const StoreActions = {
    closeSuggestions: ()=>({
            type: StoreTypes.CLOSE_SUGGESTIONS
        }),
    openSuggestions: ()=>({
            type: StoreTypes.OPEN_SUGGESTIONS
        }),
    setQuery: (payload)=>({
            type: StoreTypes.SET_QUERY,
            payload
        }),
    setValue: (payload)=>({
            type: StoreTypes.SET_VALUE,
            payload
        }),
    setPreviousValue: (payload)=>({
            type: StoreTypes.SET_PREVIOUS_VALUE,
            payload
        }),
    setSuggestions: (payload)=>({
            type: StoreTypes.SET_SUGGESTIONS,
            payload
        }),
    selectSuggestion: (payload)=>({
            type: StoreTypes.SELECT_SUGGESTION,
            payload
        }),
    selectingSuggestion: (payload)=>({
            type: StoreTypes.SELECTING_SUGGESTION,
            payload
        }),
    confirmSuggestion: (payload)=>({
            type: StoreTypes.CONFIRM_SUGGESTION,
            payload
        }),
    cancelSuggestion: ()=>({
            type: StoreTypes.CANCEL_SUGGESTION
        })
};

//# sourceMappingURL=types.js.map